<template>
  <v-row :class="{
    'title': true,
    'font-weight-light': true,
    'text-left': !$vuetify.breakpoint.mdAndDown,
    'text-center': $vuetify.breakpoint.mdAndDown,
  }">
    <v-col
      style="cursor: pointer"
      cols="12"
      v-for="(link, index) in links"
      :key="index"
      @click="routeHandler(link.name)"
    >
      {{ link.text }}
    </v-col>

    <v-col
      style="cursor: pointer"
      cols="12"
      @click="downloadRules"
    >
      Политика конфиденциальности
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Links",
  data() {
    return {
      links: [
        {name: 'Home', text: 'Главная'},
        {name: 'About', text: 'Обо мне'},
        {name: 'Record', text: 'Записаться на консультацию'},
        {name: 'Contact', text: 'Контакты'},
      ],
    }
  },
  methods: {
    routeHandler(route) {
      this.$router.push({name: route});
    },
    async downloadRules() {
      try {
        const response = await fetch('privacy_policy.docx');
        const blob = await response.blob();
        this.downloadFile(blob, 'privacy_policy.docx');
      } catch (e) {
        console.log(e);
      }
    },
    downloadFile(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  }
}
</script>

<style scoped>
.link {
  text-decoration: none;
  transition: 0.1s linear;
  font-size: 1em;
  color: white;
  white-space: normal;
}

.link:hover {
  color: #d6d6d6;
}
</style>
